import React from "react";
import { FormComponent } from "./FormComponent";
import { Control, FieldValues, useController } from "react-hook-form";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface TextareaFieldProps<T extends FieldValues> {
	classes?: string;
	control: Control<T>;
	disabled?: boolean;
	id: string;
	inputClasses?: string;
	label: string;
	name: string;
	onFocus?: () => void;
	onInputChange?: (name: string, value: string) => void;
	placeholder?: string;
	required?: boolean;
	rows?: number;
}

export function TextareaField({
	classes,
	control,
	disabled,
	id,
	inputClasses,
	label,
	name,
	onFocus,
	onInputChange,
	placeholder,
	required,
	rows,
}: TextareaFieldProps<any>) {
	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name,
		control,
		disabled,
		rules: {
			required,
		},
	});
	const component = { id, name, label, required, errors, classes };

	const handleChange = (value: string) => {
		onInputChange && onInputChange(name, value);
		onChange(value);
	};

	return (
		<FormComponent {...component}>
			<textarea
				id={id}
				className={inputClasses}
				disabled={disabled}
				onFocus={onFocus}
				placeholder={placeholder}
				onChange={(e) => handleChange(e.target.value)}
				rows={rows || 4}
				autoComplete="off"
				value={value || ""}
			/>
		</FormComponent>
	);
}
